import { Utils } from 'versafleet-core';

const { RequestHelper: { request } } = Utils;

function receiveBillingAccount(billingAccount) {
  return {
    type: 'RECEIVE_BILLING_ACCOUNT',
    billingAccount,
  };
}

function receiveOptionAccountsSuccessful(optionBillingAccounts) {
  return {
    type: 'RECEIVE_OPTION_BILLING_ACCOUNTS',
    optionBillingAccounts,
  };
}

function fetch(id) {
  return async (dispatch) => {
    const result = await request(`/billing_accounts/${id}`, {
      method: 'GET',
    });
    dispatch(receiveBillingAccount(result.billing_account));
  };
}

function fetchOptionList() {
  return async (dispatch) => {
    const result = await request('/billing_accounts/list', {
      method: 'GET',
    });
    dispatch(receiveOptionAccountsSuccessful(result.billing_accounts));
  };
}

export default {
  fetch,
  fetchOptionList,
};
